export { default } from './HeroImage'
